import * as React from 'react';
import css from './styles/section.module.css';

interface SectionProps {
  style?: React.CSSProperties;
  bg?: string;
  children: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({ children, bg, style }) => {
  return (
    <section
      className={css.sectionContainer}
      style={{ background: bg, ...style }}
    >
      <div className={css.section}>{children}</div>
    </section>
  );
};
export default Section;
